import AbstractStorage from './AbstractStorage';
import EncryptedStorage from './EncryptedStorage';
import NativeStorage from './NativeStorage';
export default class CombinedStorage extends AbstractStorage {
    storage;
    static _instance;
    constructor() {
        super();
        this.storage = this.initStorage();
    }
    static instance() {
        return this._instance || (this._instance = new CombinedStorage());
    }
    async initStorage() {
        if (await NativeStorage.instance().isAvailable()) {
            return NativeStorage.instance();
        }
        if (await EncryptedStorage.instance().isAvailable()) {
            return EncryptedStorage.instance();
        }
        // eslint-disable-next-line no-alert
        alert('ご利用のブラウザーでは記入したコンテンツは保存されません。');
        throw new Error('No storage available!');
    }
    async getItem(key) {
        const storage = await this.storage;
        return storage.getItem(key);
    }
    async setItem(key, value) {
        const storage = await this.storage;
        return storage.setItem(key, value);
    }
    async removeItem(key) {
        const storage = await this.storage;
        return storage.removeItem(key);
    }
    async isAvailable() {
        const storage = await this.storage;
        return storage.isAvailable();
    }
}
